module.exports = __webpack_public_path__ + "static/media/wallet-connect.37f2bc6e.svg";